// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_63-6";
export var headerCell = "_63-2";
export var loadingStateContent = "_63-8";
export var rowWrapper = "_63-4";
export var stickyAggregationCell = "_63-b";
export var stickyAggregationRow = "_63-7";
export var stickyColumnCell = "_63-a";
export var stickyColumnHeaderCell = "_63-9";
export var table = "_63-1";
export var virtualRowWrapper = "_63-5";
export var virtualTableContainer = "_63-0";
export var white = "_63-3";